const base = import.meta.env.VITE_API_URL || ''

async function request(path, options) {
  const res = await fetch(`${base}${path}`, options)
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Unknown error' }))
    const message = Array.isArray(err.details) && err.details.length
      ? err.details.join(' · ')
      : err.error || `HTTP ${res.status}`
    throw new Error(message)
  }
  return res.json()
}

export function getHealth() {
  return request('/api/health')
}

export function getMeta() {
  return request('/api/meta')
}

export function postFeasibility(payload) {
  return request('/api/feasibility', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
}

// Free text -> a filled-in form. `mode` is 'fast' (deterministic, instant) or
// 'smart' (model-backed, ~3-5s). Rejections are the caller's cue to fall back
// to the manual form silently — a rate limit or an outage must never surface
// as an error on an optional convenience.
export function postParse(text, mode = 'fast') {
  return request('/api/parse', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, mode })
  })
}
